"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebProductsRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../../../shared");
const web_products_schema_1 = require("./web.products.schema");
const c = (0, core_1.initContract)();
exports.WebProductsRouter = c.router({
    getBySlug: {
        method: 'GET',
        path: '/slug/:productSlug',
        pathParams: web_products_schema_1.WebContractProductSlugPathParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_products_schema_1.WebContractGetProductResponseSchema) },
    },
    list: {
        method: 'GET',
        path: '/',
        query: web_products_schema_1.WebContractListProductsQueryParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_products_schema_1.WebContractListProductsResponseSchema) },
    },
    listFilters: {
        method: 'GET',
        path: '/filters',
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_products_schema_1.WebContractListProductFilterOptionsResponseSchema) },
    },
    listProductSuggestions: {
        method: 'GET',
        path: '/autocomplete',
        query: zod_1.default.object({ search: zod_1.default.string() }),
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_products_schema_1.WebContractGetProductAutocompleteResponseSchema) },
    },
}, { pathPrefix: '/products' });
